<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">
            {{$t("src.views.apps.yonetici.liste.title")}}

            <div class="tanimlamaButon">
                <el-tooltip :content='$t("src.views.apps.genel.refresh")'
                        :open-delay="500"
                        placement="top">
                    <el-button
                        v-on:click="refreshPage()"
                        size="mini"
                        type="text"
                        icon="el-icon-refresh"
                        class="mr-5">
                    </el-button>
                </el-tooltip>

                <el-tooltip :content='$t("src.views.apps.yonetici.tanimlama.title")' :open-delay="500" placement="bottom">
                    <el-button v-on:click="routeYonetici('Add Administrator')" size="mini" type="text" icon="el-icon-plus">
                    </el-button>
                </el-tooltip>
            </div>


        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading || stateLoading"
        :element-loading-text='loading ? $t("src.views.apps.yonetici.liste.listLoading") : $t("src.views.apps.yonetici.liste.stateLoading")'
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
            <el-col :span="23">
                <div>
                    <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9" text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-account mdi-24px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition name="slide-fade"><label v-if="selectIcon==='1'">{{$t("src.views.apps.yonetici.liste.aktifYonetici")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-account-remove mdi-24px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition  name="slide-fade"><label v-if="selectIcon==='0'">{{$t("src.views.apps.yonetici.liste.pasifYonetici")}}</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>

            <el-table
                    :data="yoneticiListesi"
                    style="width: 100%">
                <el-table-column
                    :label='$t("src.views.apps.genel.sira")'
                    type="index"
                    :index="indexMethod"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="ID"
                    :label='$t("src.views.apps.yonetici.liste.table.yoneticiID")'
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="adSoyad"
                    :label='$t("src.views.apps.yonetici.liste.table.adSoyad")'
                    width="200">
                    <template slot-scope="prop">
                        <div class="new-line-text">
                            {{prop.row.adSoyad}}  
                        </div>
                    </template>
                </el-table-column>
                
                <el-table-column
                    prop="yoneticiAdi"
                    :label='"Username"'
                    width="auto">
                </el-table-column>
               
                <el-table-column
                    :label='$t("src.views.apps.yonetici.liste.table.yetkiTuru")'
                    width="auto"
                    prop="yetkiTuru">
                    <template slot-scope="prop">
                        <p v-if="prop.row.rol === '0'">{{$t("src.views.apps.yonetici.liste.table.yetkiRol0")}}</p>
                        <p v-if="prop.row.rol === '1'">{{$t("src.views.apps.yonetici.liste.table.yetkiRol1")}}</p>
                        <p v-if="prop.row.rol === '2'">{{$t("src.views.apps.yonetici.liste.table.yetkiRol2")}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="cepTel"
                    :label='$t("src.views.apps.yonetici.liste.table.telefon")'
                    width="auto">
                </el-table-column>
                <el-table-column
                    prop="dahiliTel"
                    :label='$t("src.views.apps.yonetici.liste.table.dahili")'
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="sabitTel"
                    :label='$t("src.views.apps.yonetici.liste.table.sabit")'
                    width="150">
                </el-table-column>
                <el-table-column
                    :label='$t("src.views.apps.genel.islem")'
                    align="right"
                    width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.yonetici.liste.yoneticidetay")' :open-delay="500" placement="bottom">
                            <el-button
                                v-if="root || yetkili ||yetkiList.yoneticiDetayla"
                                v-on:click="yoneticiDetay(scope.row)"
                                type="text"
                                size="mini"
                                icon="mdi mdi-information-variant mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.yonetici.liste.yoneticiduzenle")' :open-delay="500" placement="bottom">
                            <el-button
                                v-if="root || yetkili || yetkiList.yoneticiGuncelleme"
                                v-on:click="routeYonetici('Update Admin',scope.row)"
                                type="text"
                                class="mr-10" style="color: #f7ba2a"
                                icon="mdi mdi-circle-edit-outline mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.yonetici.liste.yoneticikaldir")' :open-delay="500" placement="bottom">
                            <el-button
                                v-if="selectIcon==='1' && (root || yetkili || yetkiList.yoneticiSil)"
                                class="buttonDel"
                                @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                type="text"
                                icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.yonetici.liste.yoneticiaktif")' :open-delay="500" placement="bottom">
                            <el-button
                                v-if="selectIcon==='0' && (root || yetkili || yetkiList.yoneticiSil)"
                                @click="yoneticiDurumChange(scope.row,scope.$index,1), deleteDialogVisible = false"
                                type="text"
                                icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                background
                layout="sizes,prev, pager, next, jumper, total"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="pageChange"
                :page-sizes="[10, 20, 50, 100]"
                :current-page.sync="page"
                :next-click.sync="page"
                :prev-click.sync="page"
                @next-click="pageChange"
                @prev-click="pageChange">
            </el-pagination>
        </div>

        <user-dialog v-if="dialogVisibleYonetici" :dialogvisible.sync="dialogVisibleYonetici" :userdata="userDataDosPharmacy"></user-dialog>

        <el-dialog :title='$t("src.views.apps.yonetici.liste.uyari")' :visible.sync="deleteDialogVisible" width="30%" center>
            <span>"{{selection.adSoyad}}" {{$t('src.views.apps.yonetici.liste.yoneticisil')}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button icon="el-icon-check" type="success" size="mini" @click="yoneticiDurumChange(selection,selectionIndex,0), deleteDialogVisible = false"></el-button>
                <el-button size="mini" type="danger" icon="el-icon-close" @click="deleteDialogVisible = false"></el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import yoneticiService from '../../../WSProvider/YoneticiService'
    import UserDialog from '@/components/UserDialog'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import jwt_decode from "jwt-decode"
    import EventBus from "@/components/event-bus";
    

    let userDataDosPharmacy = "";
    export default {
        name: "YoneticiListesi",
        mounted() {
            const self = this;

            if (localStorage.getItem("userDataDosPharmacy")) {
                userDataDosPharmacy = jwt_decode(localStorage.getItem("userDataDosPharmacy"));
                if (userDataDosPharmacy["yetkiTuru"]) {
                    if (userDataDosPharmacy["yetkiTuru"] === '1') {
                        self.root = true;
                        self.yetkiList.yoneticiSil = true;
                        self.yetkiList.yoneticiDetayla = true;
                        self.yetkiList.yoneticiGuncelleme = true;
                    }
                    if (userDataDosPharmacy["yetkiTuru"] === '2') {
                        self.yetkiList.yoneticiSil = true;
                        self.yetkiList.yoneticiDetayla = true;
                        self.yetkiList.yoneticiGuncelleme = true;
                    }
                }
            }
            this.getYoneticiCount();
            this.getFirmaYoneticiList();

            EventBus.$on("yoneticiList", function(bool){
                if(bool){
                    self.getFirmaYoneticiList();
                    self.getYoneticiCount();
                }
            })
        },
        components: {
            UserDialog,
        },
        watch: {
            page(val) {
                this.postPage = (val - 1) * this.sizes;
            },
            sehir(newValue){
                if(newValue === "") this.musteriForm.ilce = ""
            }
        },
        data() {
            return {
                stateLoading: false,
                loading: false,
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                root: false,
                yetkili: false,
                yetkiList: {
                    yoneticiDetayla: false,
                    yoneticiGuncelleme: false,
                    yoneticiSil: false,
                },
                dialogVisibleYonetici: false,
                userDataDosPharmacy: {},
                visibleSil: false,
                deleteDialogVisible: false,
                selection: '',
                selectionIndex: '',
                yoneticiListesi: [],
            }
        },
        methods: {
            refreshPage(){
                this.stateLoading = false;
                this.loading = false;
                this.page = 1;
                this.postPage = 0;
                this.getFirmaYoneticiList();
                this.getYoneticiCount();
            },
            yoneticiDetay(scope) {
                this.userDataDosPharmacy = scope;
                this.dialogVisibleYonetici = true;
            },
            handleChange(event) {
                this.selectIcon = event;
                this.postPage = 0;
                this.getFirmaYoneticiList();
                this.getYoneticiCount();
            },
            getFirmaYoneticiList() {
                this.loading = true;
                yoneticiService.yoneticiListe(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status == 200) {
                        localStorage.setItem("userDataDosPharmacy", response.token)
                        this.yoneticiListesi = response.data
                    }
                    this.loading = false;
                }).catch(err => {
                    if(err.responseJSON){
                        let error = err.responseJSON
                        if(error.status == 401){
                            notification.Status(150, this);
                        }else if(error.status == 404){
                            this.yoneticiListesi = [];
                        }
                        else notification.Status("errorMsg", this, error.errMsg)
                    }else{
                        // notification.Status(503, this)
                    }
                    this.loading = false;
                })
            },

            getYoneticiCount(){
                yoneticiService.yoneticiCount(this.selectIcon).then((response) => {
                    if (response.status == 200) {
                        localStorage.setItem("userDataDosPharmacy", response.token)
                        this.total = parseInt(response.data)
                    }
                }).catch(err => {
                    if(err.responseJSON){
                        let error = err.responseJSON
                        if(error.status == 401){
                            notification.Status(150, this);
                        }else if(error.status == 404){
                            this.total = 0;
                        }
                    }else{
                        // notification.Status(503, this)
                    }
                }) 
            },
            yoneticiDurumChange(selection, index, durum) {
                this.$confirm("Are you sure you want to update admin's status?", this.$t("src.views.apps.marka.tanimlama.warning"), {
                    confirmButtonText: this.$t("src.views.apps.genel.yes"),
                    cancelButtonText: this.$t("src.views.apps.genel.no"),
                    type: 'warning'
                }).then(() => {
                    this.stateLoading = true;
                    if(durum === 0){
                        yoneticiService.yoneticiPasifYap(selection.ID).then(response => {
                            if(response.status == 200){
                                localStorage.setItem("userDataDosPharmacy", response.token)
                                notification.Status("success", this, response.msg)
                                this.getFirmaYoneticiList();
                                this.getYoneticiCount();
                            }
                            this.stateLoading = false;
                        }).catch(err => {
                            if(err.responseJSON){
                                let error = err.responseJSON
                                if(error.status == 401){
                                    notification.Status(150, this);
                                }
                                else notification.Status("errorMsg", this, error.errMsg)
                            }else{
                                // notification.Status(503, this)
                            }
                            this.stateLoading = false;
                        })
                    }
                    else if(durum === 1){
                        this.stateLoading = true;
                        yoneticiService.yoneticiAktifYap(selection.ID).then(response => {
                            if(response.status == 200){
                                localStorage.setItem("userDataDosPharmacy", response.token)
                                notification.Status("success", this, response.msg)
                                this.getFirmaYoneticiList();
                                this.getYoneticiCount();
                            }
                            this.stateLoading = false;
                        }).catch(err => {
                            if(err.responseJSON){
                                let error = err.responseJSON
                                if(error.status == 401){
                                    notification.Status(150, this);
                                }
                                else notification.Status("errorMsg", this, error.errMsg)
                            }else{
                                // notification.Status(503, this)
                            }
                            this.stateLoading = false;
                        })
                    }
                })
                
            },
            routeYonetici(title, scope) {
                if (scope) {
                    this.$store.commit('changeYoneticiUpdateData', scope);
                }
                functions.routeSayfa(title, this)
            },

            handleSizeChange(val) {
                this.sizes = val;
                this.getFirmaYoneticiList();
                this.getYoneticiCount();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getFirmaYoneticiList();
                this.getYoneticiCount();
                document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
            },

            indexMethod(index){
                return ((this.page - 1)* 10) + index + 1;
            },
        }
    }
</script>
<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .el-radio-button--mini .el-radio-button__inner {
        padding: 0 10px !important;
        font-size: 11px;
        border-radius: 0;
    }

    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>